module.exports = __webpack_public_path__ + "static/scale-model-of-the-rocks-in-durham-north-carolina-239858a91ed06126f39c053d1ad7b85f.png";